// extracted by mini-css-extract-plugin
export default {"kindTips":"promptDialog_kindTips__0s9QA","warpper":"promptDialog_warpper__7ZcNU"};